export enum TradeOfferResultE {
  SUCCESS_OFFER = 'success',
  FAILURE_OFFER = 'failure',
  SUCCESS_OFFER_ACCEPT = 'successAccept',
  SUCCESS_OFFER_REJECT = 'successReject',
  FAILURE_OFFER_ACCEPT = 'failurePending',
  FAILURE_OFFER_REJECT = 'failureReject',
}
